module.exports = __webpack_public_path__ + "static/media/art11.52af900f.jpg";